document.addEventListener("DOMContentLoaded", () => {
  $('.reviews-b-list').slick({
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    gap: 20,
    arrows: true,
    nextArrow:
      '<svg class="arrow-right" width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.5 16.4941L29.5 25.4941L20.5 34.4941" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><rect x="49" y="49.4941" width="48" height="48" rx="24" transform="rotate(-180 49 49.4941)" stroke="white" stroke-width="2"/></svg>',
    prevArrow:
      '<svg class="arrow-left" width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.5 34.4941L20.5 25.4941L29.5 16.4941" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><rect x="1" y="1.49414" width="48" height="48" rx="24" stroke="white" stroke-width="2"/></svg>',
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
        },
      },
    ],
  });

  $('.reviews-b').css('padding', '60px 0px');
  $('.reviews-b').height('auto');
});
